import React, { useState } from 'react';
import { api } from '../api/client';

export default function GlobalGiftPanel() {
  const [giftType, setGiftType] = useState('points');
  const [amount, setAmount] = useState('');
  const [reason, setReason] = useState('');
  const [rewardDetail, setRewardDetail] = useState('1g Nug - Free Pickup');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);

  const handleGift = async () => {
    if ((giftType === 'points' || giftType === 'spins') && (!amount || parseInt(amount) <= 0)) return;
    setLoading(true);
    setMsg(null);
    try {
      let data;
      if (giftType === 'points') {
        data = await api.post('/admin/gift-all-points', { amount: parseInt(amount), reason });
      } else if (giftType === 'spins') {
        data = await api.post('/admin/gift-all-spins', { amount: parseInt(amount) });
      } else {
        data = await api.post('/admin/gift-all-coupons', { reward_detail: rewardDetail });
      }
      setMsg({ type: 'success', text: `Gifted to ${data.affected} users` });
      setAmount('');
      setReason('');
    } catch (err) {
      setMsg({ type: 'error', text: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <h3 style={{ marginBottom: 12 }}>Gift All Users</h3>

      {msg && (
        <div style={{ padding: '8px 12px', borderRadius: 'var(--radius-sm)', marginBottom: 12, fontSize: 13,
          background: msg.type === 'success' ? 'rgba(72,187,120,0.1)' : 'rgba(252,129,129,0.1)',
          color: msg.type === 'success' ? 'var(--success)' : 'var(--danger)',
          border: `1px solid ${msg.type === 'success' ? 'var(--success)' : 'var(--danger)'}`,
        }}>
          {msg.text}
        </div>
      )}

      <div style={{ marginBottom: 12 }}>
        <label style={{ display: 'block', fontSize: 12, color: 'var(--text-secondary)', marginBottom: 4 }}>Gift Type</label>
        <select value={giftType} onChange={e => setGiftType(e.target.value)}>
          <option value="points">Bud Points</option>
          <option value="spins">Spin Tokens</option>
          <option value="coupons">Coupons</option>
        </select>
      </div>

      {(giftType === 'points' || giftType === 'spins') && (
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', fontSize: 12, color: 'var(--text-secondary)', marginBottom: 4 }}>Amount</label>
          <input type="number" min="1" value={amount} onChange={e => setAmount(e.target.value)} placeholder="e.g. 50" />
        </div>
      )}

      {giftType === 'points' && (
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', fontSize: 12, color: 'var(--text-secondary)', marginBottom: 4 }}>Reason (optional)</label>
          <input type="text" value={reason} onChange={e => setReason(e.target.value)} placeholder="Holiday bonus" />
        </div>
      )}

      {giftType === 'coupons' && (
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', fontSize: 12, color: 'var(--text-secondary)', marginBottom: 4 }}>Reward</label>
          <select value={rewardDetail} onChange={e => setRewardDetail(e.target.value)}>
            <option value="1g Nug - Free Pickup">1g Nug</option>
            <option value="2g Nug - Free Pickup">2g Nug</option>
            <option value="3.5g Nug - Free Pickup">3.5g Nug</option>
            <option value="7g Nug - Free Pickup">7g Nug</option>
            <option value="14g Nug - Free Pickup">14g Nug</option>
            <option value="Pre-Roll - Free Pickup">Pre-Roll</option>
          </select>
        </div>
      )}

      <button className="btn-primary btn-small" onClick={handleGift} disabled={loading}>
        {loading ? 'Gifting...' : 'Gift All Users'}
      </button>
      <p style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 8, marginBottom: 0 }}>
        Applies to all active non-admin users
      </p>
    </div>
  );
}
